<template>
  <div id="businessList">
    <div class="container">
      <el-row>
        <div class="left">
          <!-- <el-button
            size="small"
            :class="type == 1 ? 'heightLight' : ''"
            @click="getData(1)"
            >培训发展</el-button
          > -->
          <el-button
            size="small"
            :class="type == 2 ? 'heightLight' : ''"
            @click="getData(2)"
            >人才招聘</el-button
          >
        </div>
        <div class="right">
          <el-button type="success" icon="el-icon-s-order" @click="addNew()"
          v-if="type == 2||(type == 1&&tableData.length==0)"
            >添加</el-button
          >
          <el-button
            type="danger"
            icon="el-icon-delete"
            v-if="type==2"
            @click="handleDelete(deleteArr)"
            >批量删除</el-button
          >
        </div>
      </el-row>
      
      <el-table
        :data="tableData"
        border
        @selection-change="handleSelectionChange"
        style="width: 100%"
        :key="type"
        @sort-change="sortChange"
      >
        <el-table-column
          type="selection"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column v-if="type == 1" prop="text" label="内容">
          <template slot-scope="scope">
            <span class="showInfo">{{ decodeURI(scope.row.showInfo) }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="type == 2" prop="title" label="标题">
        </el-table-column>
        <el-table-column v-if="type == 2" prop="location" label="地址">
        </el-table-column>
        <el-table-column v-if="type == 2" prop="education" label="学历要求">
        </el-table-column>
        <el-table-column v-if="type == 2" prop="workYears" label="工作年限">
        </el-table-column>
        <el-table-column v-if="type == 2" prop="numNeed" label="招聘人数">
        </el-table-column>
        <el-table-column v-if="type == 2" prop="workContent" label="岗位职责">
           <template slot-scope="scope">
            <span class="rzyq">{{ decodeURI(scope.row.workContent) }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="type == 2" prop="postRequest" label="薪酬福利">
          <template slot-scope="scope">
            <span class="rzyq">{{ decodeURI(scope.row.postRequest) }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="type == 2" prop="workStatus" label="任职要求">
          <template slot-scope="scope">
            <span class="rzyq">{{ decodeURI(scope.row.workStatus) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" v-if="type == 2" label="创建时间" :sortable="'custom'" >
          <template slot-scope="scope">
                 {{scope.row.updateTime | seTimeFilter('sjx')}}
          </template>
           </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="addNew(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              icon="el-icon-delete"
              class="red"
              v-if="type==2"
              @click="handleDelete(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      :title="type == 1 ? '添加培训发展' : '添加招聘信息'"
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
      :before-close="handleClose"
      v-if="dialogVisible"
      custom-class="editAdd"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="110px"
        class="demo-ruleForm"
      >
        <el-form-item label="标题" prop="title" v-show="type == 2">
          <el-input v-model="ruleForm.title"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="location" v-show="type == 2">
          <el-input v-model="ruleForm.location"></el-input>
        </el-form-item>
        <el-form-item label="学历要求" prop="education" v-show="type == 2">
          <el-input v-model="ruleForm.education"></el-input>
        </el-form-item>
        <el-form-item label="工作年限" prop="workYears" v-show="type == 2">
          <el-input v-model="ruleForm.workYears"></el-input>
        </el-form-item>
        <el-form-item label="招聘人数" prop="numNeed" v-show="type == 2">
          <el-input v-model="ruleForm.numNeed"></el-input>
        </el-form-item>
        <el-form-item label="岗位职责" prop="workContent" v-show="type == 2">
          <el-input type="textarea" v-model="ruleForm.workContent"></el-input>
        </el-form-item>
        <el-form-item label="任职要求" prop="workStatus" v-show="type == 2">
          <el-input type="textarea" v-model="ruleForm.workStatus"></el-input>
        </el-form-item>
        <el-form-item label="薪酬福利" prop="postRequest" v-show="type == 2">
          <el-input type="textarea" v-model="ruleForm.postRequest"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAdd()">取 消</el-button>
        <el-button type="primary" @click="confirmAdd">确 定</el-button>
      </span>
    </el-dialog>

 <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageNo"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>

  </div>
</template>

<script>
import {
  getRecruitList,
  addRecruit,
  getSysTrain,
  editRecruit,
  delRecruit,
  delSysTrain,
} from "@/api/manage/index.js";
export default {
  data() {
    return {
      type: 2,
      dialogVisible: false,
      key: 2,
      query: {
        pageNo: 1,
        pageSize: 5,
        sortType:'a'
      },
      pageTotal:0,
      tableData: [],
      deleteArr: [],
      isEdit: false,
      editId: "",
      ruleForm: {
        title: "",
        location: "",
        education: "",
        workYears: "",
        numNeed: "",
        workContent: "",
         postRequest: "",//薪酬福利
        workStatus: "",
      },
      rules: {
        title: [
          {
            required: true,
            message: "请输入标题",
            trigger: ["blur", "change"],
          },
        ],
        location: [
          {
            required: true,
            message: "请输入地址",
            trigger: ["blur", "change"],
          },
        ],
        education: [
          {
            required: true,
            message: "请输入学历要求",
            trigger: ["blur", "change"],
          },
        ],
        workYears: [
          {
            required: true,
            message: "请输入工作年限",
            trigger: ["blur", "change"],
          },
        ],
        numNeed: [
          {
            required: true,
            message: "请输入招聘人数",
            trigger: ["blur", "change"],
          },
        ],
        workContent: [
          {
            required: true,
            message: "请输入岗位职责",
            trigger: ["blur", "change"],
          },
        ],
        // postRequest: [
        //   {
        //     required: true,
        //     message: "请输入薪酬福利",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        workStatus: [
          {
            required: true,
            message: "请输入任职要求",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  created() {
    this.getData(2);
  },
  mounted() {},
  methods: {
    async getData(type) {
      //获取信息列表
      this.type = type;
      if (type == 2) {
        let res = await getRecruitList(this.query);
        console.log('招聘',res);
        if (res.code == "40001") {
          this.tableData = [];
        } else if (res.code == "200") {
          this.pageTotal=+res.total
          this.tableData = [];
          this.tableData = res.data;
        }
      } else if (type == 1) {
        this.tableData = [];
        let res = await getSysTrain();
        if (res.code == "40001") {
        } else if (res.code == "200") {
          this.tableData = [res.data]
          
          let aa = decodeURI(this.tableData[0].text)
        //  console.log('aa',this.tableData[0].text);
          var afstr=aa.replace(/<[^>]+>/g,"")
           afstr = afstr.replace(/(\s|&mdash;|&nbsp;|&ldquo;|&rdquo;|&hellip;)/g,'');//拿到展示的文本，
            this.tableData[0].showInfo = afstr
         // console.log("this.tableData", this.tableData);
        }
      }
    },
    handleClose(done) {
      //弹窗关闭前的钩子
      done();
    },
    addNew(data) {
      //新增
      if (this.type == 2) {
        this.dialogVisible = true;
        if (data) {
          this.isEdit = true;
          this.editId = data.id;
          for (let k in this.ruleForm) {
            this.ruleForm[k] = JSON.parse(JSON.stringify(data[k]));
          }
        } else {
          this.isEdit = false;
          this.editId = "";
          for (let k in this.ruleForm) {
            this.ruleForm[k] = "";
          }
        }
      } else if (this.type == 1) {
        if (!data) {
          this.$router.replace({
            name: "talentsAdd",
            params: { typeOf: "add" },
          });
        } else{
          this.$router.replace({
            name: "talentsAdd",
        params: { typeOf: "edit",id:data.id,text:data.text },
          })
        }
      }
    },
    cancelAdd() {
      //取消添加
      this.dialogVisible = false;
    },
    confirmAdd() {
      //人才招聘确认添加,确认编辑
      this.$refs["ruleForm"].validate(async (valid) => {
        if (valid) {
          if (this.isEdit) {
            let param = JSON.parse(JSON.stringify(this.ruleForm));
            param.id = this.editId;
            let res = await editRecruit(param);
          //  console.log("res", res);
            if (res.code == 200) {
              this.$message.success("编辑成功！");
              this.dialogVisible = false;
              this.getData(2);
            }
          } else {
            let res = await addRecruit(this.ruleForm);
            if (res.code == 200) {
              this.$message.success("添加成功！");
              this.dialogVisible = false;
              this.getData(2);
            }
          }
        } else {
          return false;
        }
      });
    },
    handleSelectionChange(val) {
      //多选操作,批量删除
      this.deleteArr = [];
      val.map((item) => {
        this.deleteArr.push(item.id);
      });
    },
    handleDelete(ids) {
      //删除,批量删除
      if (ids.length == 0) {
        return this.$message.error("未选择删除项");
      }
      this.$confirm("此操作将永久删除该招聘信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let param = {};
            param.ids = Array.isArray(ids)
              ? JSON.stringify(ids)
              : JSON.stringify([ids]);
          if (this.type == 2) {
            let res = await delRecruit(param);
            if (res.code == 200) {
               if((JSON.parse(param.ids)).length==this.tableData.length){
              console.log('456456');
             this.query.pageNo--
           }
              this.$message.success("删除成功！");
              this.getData(2);
            }
          }else if(this.type ==1){
              let param2={}
              param2.id = Array.isArray(ids)
              ? ids[0]
              : ids;
              let res = await delSysTrain(param2)
              if (res.code == 200) {
              this.$message.success("删除成功！");
              this.getData(1);
            }
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handlePageChange(val) {
          this.$set(this.query, 'pageNo', val);
          this.getData(2)
      },
    sortChange(){
         this.query.sortType?this.query.sortType='':this.query.sortType='a'
          this.getData(this.type)
      },
  },
  watch: {
    "ruleForm.numNeed": function (newValue, oldValue) {
      let reg = /(^[1-9]\d*$)/; //插图id只能输入正整数
      if (reg.test(newValue)) {
        this.ruleForm.numNeed = newValue;
      } else if (newValue !== "") {
        this.ruleForm.numNeed = oldValue;
      }
    },
  },
};
</script>

<style lang="less" scoped>
#businessList {
  height: 100%;
}
.container {
  padding: 30px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
}
.red {
  color: #f56c6c;
}
.heightLight {
  color: #3a8ee6;
  border-color: #3a8ee6;
  outline: 0;
  background-color: #ecf5ff;
}
.left {
  float: left;
}
.right {
  float: right;
}
.el-form /deep/ .el-textarea__inner {
  min-height: 100px !important;
}
.showInfo{
  display: -webkit-box;
-webkit-box-orient: vertical;
-webkit-line-clamp: 2;
overflow: hidden;
}
.gwzz{
 display: -webkit-box;
-webkit-box-orient: vertical;
-webkit-line-clamp: 3;
overflow: hidden;
}
.rzyq{
 display: -webkit-box;
-webkit-box-orient: vertical;
-webkit-line-clamp: 3;
overflow: hidden;
}
</style>